export const DeliveryMode = {
	Pickup: 0,
	HomeDelivery: 1,
};
